import Immutable from 'immutable';

function merger(a, b) {
  if (a && a.mergeWith && !Immutable.List.isList(a) && !Immutable.List.isList(b)) {
    return a.mergeWith(merger, b);
  }
  return b;
}

export default function createEntitiesReducer(key) {
  const initialState = Immutable.Map();

  return function entityReducer(state = initialState, action) {
    const payload = action.payload || {};
    const entities = action.entities || payload.entities;
    const deletedEntities = action.deletedEntities || payload.deletedEntities;

    if (entities || deletedEntities) {
      let updated = state;
      if (deletedEntities) {
        deletedEntities.forEach(entityPath => {
          const [rootKey, ...path] = entityPath.split('.');
          if (rootKey === key) {
            updated = updated.deleteIn(path);
          }
        });
      }

      if (entities && entities[key]) {
        updated = updated.mergeWith(merger, entities[key]);
      }
      return updated;
    }

    return state;
  };
}
